import {SkeletonAvatar, SkeletonBox} from '@primer/react/experimental'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './ActivityTimelineSkeleton.module.css'

const ROW_WIDTHS = [styles.textLong, styles.textMedium, styles.textShort, styles.textMedium, styles.textLong] as const

/**
 * Skeleton placeholder that mimics the layout of activity timeline items
 * (icon badge + avatar + text description). Used as a Suspense fallback
 * while the Activity tab data is lazy-loaded.
 */
export function ActivityTimelineSkeleton({rows = 5}: {rows?: number}) {
  return (
    <div
      className={styles.container}
      data-testid={TEST_IDS.activityTimelineSkeleton}
      role="status"
      aria-busy
      aria-label="Loading activity"
    >
      {Array.from({length: rows}, (_, i) => (
        <div key={i}>
          <div className={styles.divider}>
            <div className={styles.dividerLine} />
          </div>
          <div className={styles.row}>
            <SkeletonAvatar size={20} />
            <SkeletonAvatar size={16} />
            <SkeletonBox className={ROW_WIDTHS[i % ROW_WIDTHS.length]} />
          </div>
        </div>
      ))}
    </div>
  )
}
